import { IHero } from "@src/components/Hero";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import { getCookie } from "cookies-next";
import { useTransform, useViewportScroll, motion } from "framer-motion";
import Image from "next/image";
import React from "react";
import image from "../../../../public/images/image10.png";
import Invitation from "src/components/modals/Invitation";
import { useFloater } from "@src/hooks/useFloater";
import Dialog from "@src/components/Dialog";

const Hero: React.FC<IHero> = ({
  eventId,
  heroImageData,
  slugData,
  loading,
  eventUuid,
  // openInvitationModal,
}) => {
  const { scrollY } = useViewportScroll();
  const y1 = useTransform(scrollY, [0, 300], [0, 60]);
  const currentAccessToken = getCookie("tsl") as string;
  const [show, setShow] = React.useState<boolean>(false);

  const [openRsvp, setOpenRsvp] = React.useState<boolean>(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div className="w-full h-[100vh] relative overflow-hidden">
      {/* Header */}
      {/* <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.8,
            ease: [0.79, 0.14, 0.15, 0.86],
          },
        }}
        className="absolute top-0 left-0 w-full z-[5] pt-8 px-4 bg-transparent"
      >
        <div className="w-full px-2 md:px-6 flex justify-between items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                delay: 0.2,
                duration: 0.6,
              },
            }}
            className="uppercase text-white font-light font-sans tracking-[0.2rem] mb-2 text-xs md:text-base"
          >
            {loading
              ? "..."
              : !!slugData?.eventBySlug && !!slugData?.eventBySlug?.hash_tag
              ? slugData?.eventBySlug?.hash_tag
              : ""}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                delay: 0.2,
                duration: 0.6,
              },
            }}
            className="text-white font-light font-sans tracking-[0.1rem] text-xs md:text-base mb-2"
          >
            LAGOS, NIGERIA
          </motion.div>
        </div>
      </motion.header> */}

      {/* Background Image */}
      <motion.div
        initial={{ scale: 1 }}
        animate={{
          scale: 1.1,
          transition: {
            delay: 0.3,
            duration: 0.8,
            ease: [0.79, 0.14, 0.15, 0.86],
          },
        }}
        className={
          "relative top-0 bottom-0 right-0 left-0 w-full h-full after:absolute after:w-full after:h-full after:bg-template-2-hero"
        }
      >
        <Image
          // placeholder="blur"
          loading="eager"
          layout="fill"
          // blurDataURL={`data:image/svg+xml;base64,${toBase64(
          // shimmer(700, 475)
          // )}`}
          src={
            !!heroImageData.getHeroImage ? heroImageData.getHeroImage : image
          }
          alt="gallery-image"
          className="object-cover object-center"
        />
      </motion.div>

      {/* Main Content */}
      <div className="w-full h-full absolute left-0 top-0 z-[4]">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: {
              delayChildren: 1,
              staggerChildren: 1.5,
            },
          }}
          viewport={{ once: true }}
          className={
            "w-full h-full flex flex-col justify-start text-right px-6"
          }
        >
          <motion.h5
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className={
              "text-[1.5rem] lg:text-[3rem] text-white font-andalusia font-light my-4 sm:my-8 leading-[100%] capitalize"
            }
          >
            {slugData?.eventBySlug?.name}
          </motion.h5>

          {currentAccessToken ? (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: {
                  duration: 1,
                  ease: [0.79, 0.14, 0.15, 0.86],
                },
              }}
              className="flex justify-end mx-4"
            >
              <Dialog
                trigger={
                  <motion.div
                    // style={{ y: y1 }}
                    className="mt-4 bg-[rgba(0,0,0,0.42)] border border-white font-brooklyn text-white px-6 py-2 flex items-center justify-center rounded"
                    onClick={() => setOpenRsvp(true)}
                  >
                    RSVP
                  </motion.div>
                }
                open={openRsvp}
                onOpenChange={setOpenRsvp}
              >
                <Invitation
                  name={slugData?.eventBySlug?.name ?? ""}
                  date={slugData?.eventBySlug?.date ?? ""}
                  eventId={eventId}
                  setOpen={setOpenRsvp}
                  access_control={
                    slugData?.eventBySlug?.event_preference?.access_control ??
                    false
                  }
                  eventUuid={`${slugData?.eventBySlug?.uuid}`}
                  eventSlug={slugData?.eventBySlug?.slug ?? ""}
                  passImage={slugData?.eventBySlug?.pass_image ?? ""}
                />
              </Dialog>
            </motion.div>
          ) : (
            <></>
          )}

          {/* <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="font-light font-brooklyn text-[1rem] sm:text-[1.5rem] text-white leading-[100%] mb-[3rem]"
          >
            {loading
              ? "..."
              : !!slugData?.eventBySlug && !!slugData?.eventBySlug?.welcome_msg
              ? slugData?.eventBySlug?.welcome_msg
              : ""}
          </motion.p> */}
          {/* <motion.div className="relative h-[19%] w-full max-w-[29.3rem] mb-4 md:mb-0">
            <Image
              placeholder="blur"
              loading="eager"
              layout="fill"
              src={weddingLogo}
              alt="gallery-image"
              className="object-contain"
            />
          </motion.div> */}
          {/* <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 1,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="text-[2rem] md:text-[4rem] text-white leading-[120%] tracking-[0.2rem] font-dacing"
          >
            #theKSnuptials24
          </motion.p> */}
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
